import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c1be07ca&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c1be07ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1be07ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1be07ca')) {
      api.createRecord('c1be07ca', component.options)
    } else {
      api.reload('c1be07ca', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c1be07ca&scoped=true&", function () {
      api.rerender('c1be07ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B94e5pSPe1yx/JS/comp/GuestBox.vue"
export default component.exports